<div style="flex: 1 1 100%; flex-direction: column;display: flex;" *ngIf="visible">
  <button mat-button type="button" color="primary" (click)="onClick($event)">{{ label | translate }}</button>
</div>
